import { IRequestType } from "./type"

const attendanceBaseUrl= '/employee/biometrics'

export const AttendanceEndpointConst={
    attendanceList: `${attendanceBaseUrl}/list`,
    biometricUpdate: `${attendanceBaseUrl}`
} 

export const getBiometricUserByIdUrl = (params: IRequestType) => {
    return `${attendanceBaseUrl}/${params.id}/details`
}
